<template>
  <div id="app">
    <!-- <transition :name="transitionName"> -->
      <router-view/>
    <!-- </transition> -->
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      transitionName: null
    }
  },
  watch: {
    $route(to, from) {
      if (from.name == 'map-your-meal') {
        this.transitionName = 'slide-left'
      }

      if (from.name == 'breakdown') {
        this.transitionName = 'slide-right'
      }
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&family=Oswald:wght@500;600&family=Roboto:wght@500;700&display=swap');
@import 'assets/styles/vars';
@import 'assets/styles/main';

* {
  padding: 0;
  margin: 0;
}
.menu-open {
  overflow: hidden;
}

.hidden {
  visibility: hidden;
  opacity: 0;
}
#app {
  font-family: 'Montserrat';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  font-weight: $fwReg;
  color: $cBlack;

  // Starting enter point
  .slide-left-enter {
    transform: translate3d(-100%, 0, 0);
    opacity: 0;
  }
  // Ending enter point (Default view)
  .slide-left-enter-to {
    transform:translate3d(0, 0, 0);
    opacity: 1;
  }
  // Enter animation
  .slide-left-enter-active {
    transition: all 0.65s ease-out;
  }
  // Leaving starting point (Default view)
  .slide-left-leave {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
  // Leaving ending point
  .slide-left-leave-to {
    transform: translate3d(-100%, 0, 0);
    opacity: 0;
  }
  // Leave animation
  .slide-left-leave-active {
    transition: all 1s cubic-bezier(0.61, 0, 0.38, 0.99);
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .slide-in-left-enter-active {
    transition: all 1s cubic-bezier(0.61, 0, 0.38, 0.99);
    transform: translate(0,0,0);
    opacity: 1;
  }
  .slide-in-left-leave-active {
    transition: all 1s ease-out;
    opacity: 0;
  }
  .slide-in-left-enter {
    transform: translate3d(100%, 0, 0);
    opacity: 0;
    position: absolute;
  }

  .slide-in-left-leave-to {
    transform: translate3d(-100%, 0, 0);
    position: absolute;
    opacity: 0;
  }

  .m-left-enter-active, .m-left-leave-active {
    transition: all 1s cubic-bezier(0.61, 0, 0.38, 0.99);
    transform: translate(0,0,0);
    opacity: 1;
  }
  .m-left-enter {
    transform: translate3d(100%, 0, 0);
    opacity: 0;
    position: absolute;
  }

  .m-left-leave-to {
    transform: translate3d(-100%, 0, 0);
    position: absolute;
    opacity: 0;
  }

  .m-right-enter-active, .m-right-leave-active {
    transition: all 1s cubic-bezier(0.61, 0, 0.38, 0.99);
    transform: translate(0,0,0);
    opacity: 1;
  }
  .m-right-enter {
    transform: translate3d(-100%, 0, 0);
    opacity: 0;
    position: absolute;
  }

  .m-right-leave-to {
    transform: translate3d(100%, 0, 0);
    position: absolute;
    opacity: 0;
  }

  .mt-40 {
    margin-top: 40px;
  }
  .mb-40 {
    margin-bottom: 40px;
  }
  .btn {
    display: inline-block;
    font-family: $fSecondary;
    font-weight: $fwMed;
    font-size: 14px;
    padding-top: 12px;
    padding-bottom: 12px;
    padding-left: 20px;
    padding-right: 20px;
    text-align: center;
    border: none;
    cursor: pointer;
    text-transform: uppercase;
    text-decoration: none;
    line-height: 21px;
    &--primary-green {
      background: $cGreen;
    }
    &--secondary {
      background: $cWhite;
    }
    &--green {
      color: $cSecondaryGreen;
    }
    &--white {
      color: $cWhite;
    }
    &__icon {
      padding-left: 15px;
    }
  }
}
#nav {
  padding-top: 20px;
  padding-bottom: 20px
}
</style>
